/**
 * Viñedo navbar — oculta al cargar, aparece suave al hacer scroll.
 */
(function () {
  function smoothstep(t) {
    return t * t * (3 - 2 * t);
  }

  /**
   * @param {HTMLElement} nav
   */
  function initVinedoNav(nav) {
    if (nav.dataset.vinedoNavInit === 'true') return;
    nav.dataset.vinedoNavInit = 'true';

    const templateName = document.getElementById('MainContent')?.dataset.template || '';
    const isVendimiaPage =
      templateName === 'page.vendimia' || Boolean(document.querySelector('.vinedo-programa'));
    const alwaysVisible = nav.dataset.alwaysVisible === 'true' || isVendimiaPage;
    const fadeStart = Number(nav.dataset.fadeStart || 40);
    const fadeEnd = Number(nav.dataset.fadeEnd || 220);

    function updateNav() {
      if (alwaysVisible) {
        nav.style.setProperty('--vinedo-nav-opacity', '1');
        nav.style.setProperty('--vinedo-nav-offset', '0%');
        nav.classList.add('is-visible');
        nav.style.pointerEvents = 'auto';
        nav.setAttribute('aria-hidden', 'false');
        return;
      }

      const scroll = window.scrollY;
      const linear = Math.max(0, Math.min(1, (scroll - fadeStart) / (fadeEnd - fadeStart)));
      const progress = smoothstep(linear);

      nav.style.setProperty('--vinedo-nav-opacity', String(progress));
      nav.style.setProperty('--vinedo-nav-offset', `${(1 - progress) * -100}%`);
      nav.classList.toggle('is-visible', progress > 0);
      nav.style.pointerEvents = progress > 0.12 ? 'auto' : 'none';
      nav.setAttribute('aria-hidden', progress < 0.08 ? 'true' : 'false');
    }

    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }

  function initAllVinedoNavs() {
    document.querySelectorAll('.vinedo-nav').forEach(initVinedoNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVinedoNavs);
  } else {
    initAllVinedoNavs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const nav = event.target.matches?.('.vinedo-nav')
      ? event.target
      : event.target.querySelector?.('.vinedo-nav');

    if (nav) {
      delete nav.dataset.vinedoNavInit;
      initVinedoNav(nav);
    }
  });
})();
